/**
 * When "Allow linked deposit" is switched on, the previously linked account (if any) must not be
 * silently re-offered - the user has to pick a fresh one. When switched off, the existing linked
 * account id is left untouched (CAM-140 retains it for audit; enforcement is what's disabled).
 */
export function nextLinkedDepositAccountIdOnAllowLinkedDepositChange(allowLinkedDeposit, currentLinkedDepositAccountId) {
  return allowLinkedDeposit ? null : currentLinkedDepositAccountId;
}
